module.exports = __webpack_public_path__ + "img/ic-shipment-black.41abd529.svg";